/* eslint-disable no-undef */
import React, { Component } from "react";
import { reverseParseTextView } from "./createRender";
import Footer from "../exercise/Footer";

const $ = require("$");
const MathQuill = require("MathQuill");

const MQ = MathQuill.getInterface(2);

class Question extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
		};
	}
	toggleAnswer = (val, e) => {
		// val && cnzz.statistics('PC端作业详情页', 2, '展开答案'); /** 打点统计 */
		e.stopPropagation();
		this.setState({ visible: val });
	};
	componentDidMount() {
		$(".mathquill-embedded-latex", this.refs.viewer)
			.removeAttr("style")
			.each(function (index, item) {
				MQ.StaticMath(item);
			});
		$(".math_reading", this.refs.viewer).off();
		$(".inner_audio", this.refs.viewer) &&
			$(".inner_audio", this.refs.viewer)
				.off()
				.on("click", () => {
					$(".math_reading", this.refs.viewer)[0].play();
					$(".inner_audio", this.refs.viewer).addClass("inner-audio-play");
				});
		$(".math_reading", this.refs.viewer) &&
			$("audio", this.refs.viewer).bind("ended", () => {
				$(".inner_audio", this.refs.viewer).removeClass("inner-audio-play");
			});
		if (this.props.data.subject === "0") {
			this.setState({ visible: true }); //数学题默认答案显示
		}
	}

	componentDidUpdate() {
		$(".mathquill-embedded-latex", this.refs.viewer)
			.removeAttr("style")
			.each(function (index, item) {
				MQ.StaticMath(item);
			});
		$(".math_reading", this.refs.viewer).off();
		$(".inner_audio", this.refs.viewer) &&
			$(".inner_audio", this.refs.viewer)
				.off()
				.on("click", () => {
					$(".math_reading", this.refs.viewer)[0].play();
					$(".inner_audio", this.refs.viewer).addClass("inner-audio-play");
				});
		$(".math_reading", this.refs.viewer) &&
			$("audio", this.refs.viewer).bind("ended", () => {
				$(".inner_audio", this.refs.viewer).removeClass("inner-audio-play");
			});
	}

	createHtml = (str) => ({ __html: str ? str : `&nbsp;` });

	render() {
		const { visible } = this.state;
		let originData = this.props.data;
		// if(this.props.errorAnswer){originData.answer = this.props.errorAnswer}//题目检错页显示的是错的的答题答案

		const { num, children } = this.props;
		let data = reverseParseTextView(originData);
		return (
			<div className="box-exercise" ref={"viewer"}>
				<div className="exercise-content">
					{num !== "undefined" && (
						<div className="exercise-num">
							<p className="math_text">{`${num + 1}、`}</p>
						</div>
					)}
					<div className="exercise-con" dangerouslySetInnerHTML={this.createHtml(data.stem)} />
					{data.item_list && !!data.item_list.length && (
						<div className="exercise-options">
							{data.item_list.map((val, key) => (
								<div key={key} className="exercise-option">
									<div className="exercise-option-code">{val.code}、</div>
									<div className="exercise-option-item" dangerouslySetInnerHTML={this.createHtml(val.item)} />
								</div>
							))}
						</div>
					)}
				</div>
				<div className="exercise-footer">
					{visible && (
						<div className="footer-hide relative">
							<div>
								<div className="inline-block">
									<span style={{ fontSize: 14 }}>{this.props.errorAnswer ? "错误答案：" : "正确答案："}</span>
								</div>
								<div className="inline-block" style={{ width: "80%" }}>
									<span style={{ fontSize: 14 }} />
								</div>
							</div>
							{data.answer && (
								<div>
									<div className="inline-block">
										<span style={{ fontSize: 14 }}>答案：</span>
									</div>
									<div className="inline-block">
										<span style={{ fontSize: 14 }} dangerouslySetInnerHTML={this.createHtml(data.answer)} />
									</div>
								</div>
							)}
							{data.explain && (
								<div>
									<div className="inline-block">
										<span style={{ fontSize: 14 }}>解析：</span>
									</div>
									<div className="inline-block">
										<span style={{ fontSize: 14 }} dangerouslySetInnerHTML={this.createHtml(data.explain)} />
									</div>
								</div>
							)}
						</div>
					)}
					<div className="footer-show relative">
						<Footer {...this.props} obj={originData} subject={this.props.data.subject}>
							{this.props.canShowAnswer ? (
								<button className="question-btn" onClick={(e) => this.toggleAnswer(!visible, e)}>
									{!visible ? "显示答案" : "隐藏答案"}
								</button>
							) : null}
						</Footer>
					</div>
				</div>
			</div>
		);
	}
}

export default Question;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/spokenPinyin/viewForView.js